import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ContactsProfileComponent } from '../contacts-profile/contacts-profile.component';
import { ContactsService } from '../../../service/component_dependent/contacts/contacts.service';
import { ListComponent } from '../../shared/list/list.component';
import { Data } from '../../../model/data';
import { Contacts } from '../../../model/contacts';
import { ContactNumber } from '../../../model/contact-number';
import { GroupsService } from '../../../service/component_dependent/groups.service';
import { GroupsProfileComponent } from '../groups-profile/groups-profile.component';
import { NotifierService } from '../../../service/component_dependent/notifier.service';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-groups-home',
  templateUrl: './groups-home.component.html',
  styleUrls: ['./groups-home.component.scss']
})
export class GroupsHomeComponent implements OnInit, AfterViewInit {

  @ViewChild(GroupsProfileComponent) appGroupProfile: GroupsProfileComponent;
  @ViewChild(ListComponent) appList: ListComponent;

  protected groups: Data[];

  protected maxItemsPerPage: number = 18;
  protected total: number;
  protected page: number = 1;

  protected keyword: string = null;

  protected loading: boolean;

  protected group: any;

  constructor(private contactsService: ContactsService,
    private groupService: GroupsService,
    private notifierService: NotifierService
    ) {

  }

  ngOnInit() {
    this.initComponents();
  }

  ngAfterViewInit() {

  }

  protected openGroupProfileModal() {
    this.appGroupProfile.open();
  }

  protected initComponents() {
    this.getGroups(this.maxItemsPerPage, this.keyword, this.page);
  }

  protected getGroups(maxItemsPerPage, keyword, page) {
    this.maxItemsPerPage = maxItemsPerPage;
    this.keyword = keyword;
    this.page = page;

    this.loading = true;
    this.groupService.getGroups(maxItemsPerPage, keyword, page).subscribe(
      (dataGroups: any) => {
        this.reassignVariablesGroup(dataGroups.data);
        this.loading = false;
      },
      (errorGroups: any) => {
        this.loading = false;
      }
    );
  }

  private onEdit(obj: any) {
    this.appGroupProfile.edit(obj);
  }

  private reassignVariablesGroup(elem: any) {

    var instance: Data
    var data = elem.data;

    this.groups = new Array<Data>();
    this.total = elem.total;

    for (var i = 0; i < data.length; i++) {
      instance = new Data();
      instance.id = data[i].id;
      instance.date = data[i].created_at;
      instance.title = data[i].name;
      instance.description = data[i].description;

      this.groups.push(instance);
    }
  }

  loadingPID:boolean = false;
  fileName= ""
  selectedFile: File
  
  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    this.fileName = this.selectedFile.name;
  }

  onUpload(){
    //Validate if existing application 
    Swal.fire({
      title: 'Are you sure?',
      text: "You'll be replacing the existing group ?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, replace it'
    }).then((result) => {
      if (result.value) {
        this.fileUpload()
      }
    })


    
  }

  fileUpload(){
    this.loadingPID = true
        const uploadData = new FormData();
        uploadData.append('excel', this.selectedFile);
        uploadData.append('group_id',<any>this.group.id);
        // uploadData.append('batch_type_id',<any>this.batch.batch_type_id)
        // uploadData.append('call_type_id', <any>this.batch.call_type_id)
        
        this.groupService.uploadPID(uploadData).subscribe(
          (data) => {
            this.notifierService.showSuccess("Successfully Updated Group PID");
            Swal.fire(
              'Uploaded!',
              'Your file has been uploaded.',
              'success'
            )
          },
          (err) => {
            //this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(err.error.message));
            alert('Error' + JSON.stringify(err))
            this.notifierService.showError(err.error.message);
            this.loadingPID = false
          },
          () => {
            this.loadingPID = false
          }
        )
  }


}
